import React from 'react';
import { Crown, Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-forest-dark text-cream/80 pt-20 pb-10" data-id="element-78">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-79">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16" data-id="element-80">
          {/* Brand */}
          <div className="space-y-6" data-id="element-81">
            <div className="flex items-center gap-2" data-id="element-82">
              <div className="bg-gold p-1.5 rounded-full text-white" data-id="element-83">
                <Crown size={20} fill="currentColor" data-id="element-84" />
              </div>
              <div className="flex flex-col" data-id="element-85">
                <span className="font-serif font-bold text-lg leading-none text-white" data-id="element-86">
                  sgbeautycastle
                </span>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-cream/60" data-id="element-87">
              新加坡美丽城堡——新加坡领先的专业按摩推荐平台，自2018年起为数万用户提供安全、优质的按摩服务推荐。Singapore's
              premier massage recommendation platform since 2018.
            </p>
            <div className="flex gap-4" data-id="element-88">
              <a href="#" className="hover:text-gold transition-colors" data-id="element-89">
                <Instagram size={20} data-id="element-90" />
              </a>
              <a href="#" className="hover:text-gold transition-colors" data-id="element-91">
                <Facebook size={20} data-id="element-92" />
              </a>
              <a href="#" className="hover:text-gold transition-colors" data-id="element-93">
                <Twitter size={20} data-id="element-94" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-95">
            <h4 className="text-white font-serif font-bold text-lg mb-6" data-id="element-96">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-97">
              <li data-id="element-98">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-99">
                  About Us
                </a>
              </li>
              <li data-id="element-100">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-101">
                  Featured Shops
                </a>
              </li>
              <li data-id="element-102">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-103">
                  Partner With Us
                </a>
              </li>
              <li data-id="element-104">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-105">
                  Blog
                </a>
              </li>
              <li data-id="element-106">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-107">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-108">
            <h4 className="text-white font-serif font-bold text-lg mb-6" data-id="element-109">
              Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-110">
              <li data-id="element-111">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-112">
                  Traditional Chinese Massage
                </a>
              </li>
              <li data-id="element-113">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-114">
                  Thai Massage
                </a>
              </li>
              <li data-id="element-115">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-116">
                  Foot Reflexology
                </a>
              </li>
              <li data-id="element-117">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-118">
                  Aromatherapy SPA
                </a>
              </li>
              <li data-id="element-119">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-120">
                  Couples Massage
                </a>
              </li>
            </ul>
          </div>

          {/* Partner Links */}
          <div data-id="element-121">
            <h4 className="text-white font-serif font-bold text-lg mb-6" data-id="element-122">
              友站链接
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-123">
              <li data-id="element-124">
                <a href="https://ttvip-64.com/" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-125">
                  ttvip-64.com
                </a>
              </li>
              <li data-id="element-126">
                <a href="https://shiok27.com/" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-127">
                  shiok27.com
                </a>
              </li>
              <li data-id="element-128">
                <a href="https://xfy01.net/" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-129">
                  xfy01.net
                </a>
              </li>
              <li data-id="element-130">
                <a href="https://sgharem6.net/" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-131">
                  sgharem6.net
                </a>
              </li>
              <li data-id="element-132">
                <a href="https://qc52.me/" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-133">
                  qc52.me
                </a>
              </li>
              <li data-id="element-134">
                <a href="https://sglonelyguy.me" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-135">
                  sglonelyguy.me
                </a>
              </li>
              <li data-id="element-136">
                <a href="https://ttvip.life" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-137">
                  ttvip.life
                </a>
              </li>
              <li data-id="element-138">
                <a href="https://locanto.space" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-139">
                  locanto.space
                </a>
              </li>
              <li data-id="element-140">
                <a href="https://kkbaby.site" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-141">
                  kkbaby.site
                </a>
              </li>
              <li data-id="element-142">
                <a href="https://xfy8.com" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-143">
                  xfy8.com
                </a>
              </li>
              <li data-id="element-144">
                <a href="https://sgbeautycastle.live" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-145">
                  sgbeautycastle.live
                </a>
              </li>
              <li data-id="element-146">
                <a href="https://shiok26.site" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-147">
                  shiok26.site
                </a>
              </li>
              <li data-id="element-148">
                <a href="https://sgharem.site" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-149">
                  sgharem.site
                </a>
              </li>
              <li data-id="element-150">
                <a href="https://shiok8.xyz" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-151">
                  shiok8.xyz
                </a>
              </li>
              <li data-id="element-152">
                <a href="https://geylang777.info" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-153">
                  geylang777.info
                </a>
              </li>
              <li data-id="element-154">
                <a href="https://ttvip-62.site" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-155">
                  ttvip-62.site
                </a>
              </li>
              <li data-id="element-156">
                <a href="https://geylang666.me" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-157">
                  geylang666.me
                </a>
              </li>
              <li data-id="element-158">
                <a href="https://isyou.net" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-159">
                  isyou.net
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-160">
            <h4 className="text-white font-serif font-bold text-lg mb-6" data-id="element-161">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm" data-id="element-162">
              <li className="flex items-start gap-3" data-id="element-163">
                <MapPin size={18} className="text-gold mt-0.5" data-id="element-164" />
                <span data-id="element-165">
                  10 Anson Road, #20-15 International Plaza, Singapore 079903
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-166">
                <Phone size={18} className="text-gold" data-id="element-167" />
                <span data-id="element-168">+65 6789 1234</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-169">
                <Mail size={18} className="text-gold" data-id="element-170" />
                <span data-id="element-171">hello@beautycastle.sg</span>
              </li>
            </ul>
          </div>
        </div>

        {/* SEO Chinese Description */}
        <div className="border-t border-white/10 pt-8 mb-8" data-id="element-172">
          <p className="text-xs text-cream/30 leading-relaxed mb-3" data-id="element-173">
            新加坡美丽城堡（sgbeautycastle）是新加坡最受欢迎的专业按摩推荐平台，为您精选新加坡全岛优质按摩服务。我们的服务涵盖新加坡泰式按摩、新加坡中式推拿、新加坡足部按摩、新加坡精油SPA、新加坡运动按摩、新加坡情侣按摩、新加坡产后按摩等多种类型。
          </p>
          <p className="text-xs text-cream/30 leading-relaxed mb-3" data-id="element-174">
            新加坡美丽城堡覆盖新加坡所有主要区域：乌节路按摩、牛车水按摩、武吉士按摩、芽笼按摩、丹戎巴葛按摩、克拉码头按摩、小印度按摩、滨海湾按摩、裕廊按摩、淡滨尼按摩、碧山按摩、宏茂桥按摩等。无论您身处新加坡哪个角落，都能通过新加坡美丽城堡找到附近最好的按摩服务。
          </p>
          <p className="text-xs text-cream/30 leading-relaxed" data-id="element-175">
            作为新加坡按摩行业的领先平台，新加坡美丽城堡始终坚持严格的商家审核标准，所有入驻商家均通过资质认证和实地考察。我们致力于为新加坡居民和来新加坡旅游的游客提供安全、放心、优质的按摩体验推荐。选择新加坡美丽城堡，享受新加坡最好的按摩服务。
          </p>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-cream/40" data-id="element-176">
          <p data-id="element-177">© 2026 新加坡美丽城堡 sgbeautycastle. All rights reserved.</p>
          <p data-id="element-178">Made with ♥ in Singapore</p>
        </div>
      </div>
    </footer>;
}